<div class="wrap">

  <div class="spinner" *ngIf="isLoading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <div class="title">
    <fa-icon [icon]="faChevronLeft" class="back" (click)="!save ? back() : openDialogConfirmSave()"></fa-icon>
    <h4>Mes trophées</h4>
    <div class="action_save">
      <fa-icon [icon]="faSave" class="save" (click)="saveWallOfTrophy()" *ngIf="save"></fa-icon>
    </div>
  </div>
  <div class="wall">
    <fa-icon class="background_image" [icon]="faImage" (click)="openDialogUpdatebackgorund()"></fa-icon>
    <div class="transparence" id="background_trophy">
    </div>
    <div class="shelfs">
      <div class="shelf" *ngFor="let s of shelfsArray"></div>

    </div>



    <div class="drag_drop_container" cdkDropListGroup>

      <div cdkDropList [cdkDropListEnterPredicate]="dropListEnterPredicate" (cdkDropListDropped)="dropListDropped()">
      </div>
      <div cdkDropList *ngFor="let t of trophies, let i = index" [cdkDropListEnterPredicate]="dropListEnterPredicate"
        (cdkDropListDropped)="dropListDropped()"
        [ngClass]="{trophy: !longtouch , trophy_shake: longtouch, add: longtouch && t.type=== 'add'}">
        <div cdkDrag class=" example-box" (cdkDragMoved)="dragMoved($event);" [cdkDragDisabled]="!longtouch">

          <ng-container [ngSwitch]="t?.type">

            <fa-icon *ngSwitchCase="'add'" [icon]="faPlus" (click)="openDialogChoiceTrophy('new')"></fa-icon>
            <!-- <div class="trophy_position"> -->
            <img *ngSwitchCase="'Trophy'" class="icone_trophy" [src]="getImageTrophy(t)" ngxLongPress2
              (onLongPress)="!longtouch? activeLongPress(): null"
              (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i,t) : goToTrophy()" [id]="getIdImg(i)">

            <p *ngSwitchCase="'Trophy'" class="trophy_position" ngxLongPress2
              (onLongPress)="!longtouch? activeLongPress(): null"
              (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i,t) : goToTrophy()">
              <strong>{{getSport(t.supportId)}}</strong>
            </p>

            <!-- </div> -->

            <ng-container *ngSwitchCase="'Image'">
              <a *ngIf="!longtouch && t.imageLink " [href]="t.imageLink">
                <img *ngIf="!t.imageUrl && !t.imageToAdd" [src]="(t.url|| t.imageToAdd) | imgWallOfTrophies | async"
                  ngxLongPress2 (onLongPress)="!longtouch? activeLongPress(): null"
                  (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i,t) : null" [id]="getIdImg(i)">
                <img *ngIf="t.imageToAdd" [src]="t.imageToAdd" ngxLongPress2
                  (onLongPress)="!longtouch? activeLongPress(): null"
                  (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i,t) : null" [id]="getIdImg(i)">
                <img *ngIf="t.imageUrl" [src]="t.url || t.imageUrl || t.imageToAdd  " ngxLongPress2
                  (onLongPress)="!longtouch? activeLongPress(): null"
                  (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i, t) : null" [id]="getIdImg(i)">
              </a>

              <ng-container *ngIf="!longtouch && !t.imageLink">
                <img *ngIf="!t.imageUrl && !t.imageToAdd" [src]="(t.url||  t.imageToAdd) | imgWallOfTrophies | async"
                  ngxLongPress2 (onLongPress)="!longtouch? activeLongPress(): null"
                  (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i,t) : null" [id]="getIdImg(i)">
                <img *ngIf="t.imageToAdd" [src]="t.imageToAdd" ngxLongPress2
                  (onLongPress)="!longtouch? activeLongPress(): null"
                  (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i,t) : null" [id]="getIdImg(i)">
                <img *ngIf="t.imageUrl" [src]="t.url || t.imageUrl || t.imageToAdd  " ngxLongPress2
                  (onLongPress)="!longtouch? activeLongPress(): null"
                  (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i, t) : null" [id]="getIdImg(i)">
              </ng-container>

              <ng-container *ngIf="longtouch">
                <img *ngIf="!t.imageUrl && !t.imageToAdd" [src]="(t.url||  t.imageToAdd) | imgWallOfTrophies | async"
                  ngxLongPress2 (onLongPress)="!longtouch? activeLongPress(): null"
                  (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i,t) : null" [id]="getIdImg(i)">
                <img *ngIf="t.imageToAdd" [src]="t.imageToAdd" ngxLongPress2
                  (onLongPress)="!longtouch? activeLongPress(): null"
                  (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i,t) : null" [id]="getIdImg(i)">
                <img *ngIf="t.imageUrl" [src]="t.url || t.imageUrl || t.imageToAdd  " ngxLongPress2
                  (onLongPress)="!longtouch? activeLongPress(): null"
                  (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i, t) : null" [id]="getIdImg(i)">
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'Url'">
              <a *ngIf="!longtouch" [href]="t.url">
                <img [src]="getFavicon(t.url)" ngxLongPress2 (onLongPress)="!longtouch? activeLongPress():null"
                  (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i,t) : null" [id]="getIdImg(i)">
              </a>
              <img *ngIf="longtouch" [src]="getFavicon(t.url)" ngxLongPress2
                (onLongPress)="!longtouch? activeLongPress():null"
                (click)="unlockOpenDialog? openDialogChoiceTrophy('update', i,t) : null" [id]="getIdImg(i)">

            </ng-container>

          </ng-container>

          <div class=" shadow"> </div>
          <fa-icon [icon]="faTimesCircle" class="delete" *ngIf="t?.type !== 'add' && longtouch"
            (click)="deleteTrophy(i)">
          </fa-icon>
        </div>
      </div>
    </div>
  </div>
</div>